export default __webpack_public_path__ + "static/media/atletasbkp.93d7fed8.png";